import React, { useState, useEffect } from "react";

import ReleasePersonList from "./ReleasePersonList";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { PageVisibility } from "../../../utils/PageVisibility";
import { genDisplayCount } from "../../../utils/GeneralUtils";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import {
  getPersonAdmin,
  getPersonData,
  getPersonTotalEntries,
  getPersonOwners,
  getPersonTotalPages,
} from "../../../redux/reducers/person";

type Props = {
  currentPage: number;
  perView: number;
};

const ReleaseStudentListContainer: React.FC<Props> = ({
  currentPage,
  perView,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const students = useAppSelector(getPersonData);
  const entries = useAppSelector(getPersonTotalEntries);
  const totalPage = useAppSelector(getPersonTotalPages);
  const owners = useAppSelector(getPersonOwners);
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (auth_token) {
      setIsLoading(true);

      const promise = dispatch(
        getPersonAdmin({
          auth_token: auth_token,
          is_jikei_request: true,
          status: PageVisibility.AwaitingInspection,
          page: currentPage,
          per: perView,
        })
      );

      promise.finally(() => setIsLoading(false));

      return () => {
        promise.abort();
      };
    }
  }, [currentPage, perView, auth_token]);

  return (
    <ListContentWrapper
      isLoading={isLoading}
      displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
      totalEntries={entries}
      currentPage={currentPage}
      totalPage={totalPage}
    >
      <ReleasePersonList persons={students} owners={owners} isStudent={true} />
    </ListContentWrapper>
  );
};

export default ReleaseStudentListContainer;
